    <!-- =========================================================================================
    File Name: SubscriptionStatisticsReport.vue
    Description: Subscription Statistics Report page
========================================================================================== -->

<template>
    <div id="demo-card-analytics">
        <div class="vx-row">
            <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="UserPlusIcon"
                  :statistic="countOfSubscriptionPurchase"
                  :statisticTitle="this.$t('THIS_MONTH_SUBSCRIPTION_PURCHASE')"
                  color='warning' />
            </div>

            <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="UserCheckIcon"
                  :statisticTitle="this.$t('THIS_MONTH_SUBSCRIPTION_RENEWED')"
                  :statistic="countOfSubscriptionRenewed"
                  color='success'/>
            </div>

            <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="UserXIcon"
                 :statisticTitle="this.$t('THIS_MONTH_SUBSCRIPTION_CANCELED')"
                  :statistic="countOfSubscriptionCanceled"
                  color='danger' />
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card :title="this.$t('MONTHLY_SUM_SUBSCRIPTION_PAYMENT')">
                     <div class="pl-5 pt-5">
                        <DatePicker lang="en" type="year" v-model="year" :format="datepickerFormat" width="60"></DatePicker>
                    </div>
                    <div class="pb-0">
                        <vue-apex-charts
                          type=line
                          height=360
                          :options="lineChart.chartOptions"
                          :series="series" />
                          <p class="p-3 float-right text-base">{{this.$t("TIME_ZONE_MESSAGE")}}</p>
                        <br/>
                    </div>
                </vx-card>
            </div>
        </div>
    
    </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueApexCharts from 'vue-apexcharts'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moduleReport from "@/store/report/moduleReport.js"

export default {
    components: {
        StatisticsCardLine,
        VueApexCharts,
        DatePicker
    },
    data() {
        return {
            year: this.$moment(new Date).toDate(),
            datepickerFormat: 'YYYY',

            lineChart: {
                chartOptions: {
                    chart: {
                        toolbar: { show: true },
                        dropShadow: {
                        enabled: true,
                        top: 5,
                        left: 0,
                        blur: 4,
                        opacity: 0.10,
                        },
                    },
                    stroke: {
                        curve: 'smooth',
                        dashArray: [0, 0, 10],
                        width: [4, 4, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                    },
                    legend: {
                        show: false,
                    },
                    colors: ['#F97794', '#1edec5', '#b8c2cc'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#7367F0', '#1fcadb', '#b8c2cc'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            }
                        },
                        axisTicks: {
                            show: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                        categories: [this.$t('JAN'), this.$t('FEB'), this.$t('MAR'), this.$t('APR'), this.$t('MAY'), this.$t('JUN'), this.$t('JUL'), this.$t('AUG'), this.$t('SEP'), this.$t('OCT'), this.$t('NOV'), this.$t('DEC')],
                    },
                    yaxis: {
                        tickAmount: 5,
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            },
                            formatter: function(val) {
                                return val.toLocaleString()
                            }
                        },
                    },
                    tooltip: {
                        x: { show: true }
                    }
                }
            },
        }
    },
    created() {
        if (!moduleReport.isRegistered) {
            this.$store.registerModule('dataReport', moduleReport)
            moduleReport.isRegistered = true
        }
        this.$vs.loading()
        
        this.$store.dispatch("dataReport/fetchSubscriptionReport", this.year.getFullYear())
        this.$store.dispatch("dataReport/fetchSubscriptionStatistics").then(() =>{
                this.$vs.loading.close()
        })
    },
    watch: {
        year: function() {
            this.$vs.loading()
            this.$store.dispatch("dataReport/fetchSubscriptionReport", this.year.getFullYear()).then(() =>{
                this.$vs.loading.close()
            })
        }
    },
    computed: {
        series() {
            return this.$store.state.dataReport.subscriptionReportSeries
        },
        countOfSubscriptionPurchase(){
            return this.$store.state.dataReport.countOfSubscriptionPurchase.toLocaleString()
        },
        countOfSubscriptionRenewed(){
            return this.$store.state.dataReport.countOfSubscriptionRenewed.toLocaleString()
        },
        countOfSubscriptionCanceled(){
            return this.$store.state.dataReport.countOfSubscriptionCanceled.toLocaleString()
        }
    },
    methods: {
    },
}
</script>


<style lang="scss">
#demo-card-analytics {
    .tasks-today-container {
        .tasks-today__task {
            transition: background .15s ease-out;
            .tasks-today__actions {
                display: none;
            }
            &:hover {
                background: rgba(var(--vs-primary), .04);
                .tasks-today__actions {
                    display: flex;
                }
            }
        }
    }
}

#streaming-duration-table {
    text-align: center;
}
</style>
